import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/contentProviders', request)
}

export {get}
